export const pkg = {
  name: 'isomorphic-git',
  version: '0.78.3',
  agent: 'git/isomorphic-git@0.78.3'
}
